// Welk scherm is dit?
//
// Het dashboard hangt op meerdere tv's, elk op een eigen Raspberry Pi, en
// die doen het niet allemaal hetzelfde: de ene blijft 's nachts gewoon aan
// terwijl alleen de tv uitgaat, de andere gaat er helemaal uit, en de ene
// tekent trager dan de andere. Alles wat per apparaat verschilt hoort
// daarom hier, en wordt net als de kwaliteitstrap (zie renderTier.js) via
// de URL gezet en bewaard: op een tv typ je niet makkelijk een adres, dus
// dat wil je per scherm één keer hoeven doen.
//
//   ?screen=teeview   dit scherm een naam geven, zodat je in de console
//                     ziet welke Pi iets meldt
//   ?dark=45          zo veel seconden zonder beeld telt op dit scherm als
//                     "de tv staat uit" (standaard: screenDarkMs)
//   ?dark=auto        weer terug naar de standaard

import { screenDarkMs } from "../constants";

const nameKey = "tdScreenName";
const darkKey = "tdScreenDarkMs";

function read(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    // Kiosk-modus zonder opslag: dan geldt de instelling deze sessie.
    return null;
  }
}

function write(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* niets aan te doen, en het mag het dashboard niet ophouden */
  }
}

function param(key) {
  try {
    return new URLSearchParams(window.location.search).get(key);
  } catch {
    return null;
  }
}

let cachedName = null;
let cachedDarkMs = null;

// De naam van dit scherm. Puur om te kunnen zien welke Pi iets meldt; hij
// staat nergens op het beeld. Zonder ?screen= krijgt het apparaat één keer
// een eigen naam, zodat twee Pi's in de logs niet hetzelfde heten.
export function deviceName() {
  if (cachedName) return cachedName;

  const asked = param("screen");
  if (asked) {
    write(nameKey, asked);
    cachedName = asked;
    return cachedName;
  }

  const saved = read(nameKey);
  if (saved) {
    cachedName = saved;
    return cachedName;
  }

  cachedName = `scherm-${Math.random().toString(36).slice(2, 6)}`;
  write(nameKey, cachedName);
  return cachedName;
}

// Zo lang mag het beeld stilstaan voor we zeggen dat de tv uit is. Per
// scherm in te stellen, want een trage Pi mag best een tel overslaan zonder
// dat we meteen denken dat het scherm donker is.
export function darkAfterMs() {
  if (cachedDarkMs !== null) return cachedDarkMs;

  const asked = param("dark");
  if (asked === "auto") {
    write(darkKey, "");
    cachedDarkMs = screenDarkMs;
    return cachedDarkMs;
  }

  const seconds = Number(asked);
  if (asked && Number.isFinite(seconds) && seconds > 0) {
    write(darkKey, String(seconds * 1000));
    cachedDarkMs = seconds * 1000;
    return cachedDarkMs;
  }

  const saved = Number(read(darkKey));
  cachedDarkMs = Number.isFinite(saved) && saved > 0 ? saved : screenDarkMs;
  return cachedDarkMs;
}
